/*
 * TUYEN — touch image swap for product cards.
 * On touch devices, when a finger lands on (or slides over) a product card,
 * the card crossfades to its second image. Works on every page that renders
 * the product-card snippet, including cards loaded later (load more, quick view).
 */
(function () {
  if (window.__tuyenTouchSwap) return;
  window.__tuyenTouchSwap = true;

  var ACTIVE_CLASS = 'is-touch-swap';
  var RELEASE_DELAY = 900; // ms the back image stays up after the finger lifts
  var activeCard = null;
  var releaseTimer = null;
  var rafPending = false;
  var lastX = 0;
  var lastY = 0;

  function cardAt(x, y) {
    var el = document.elementFromPoint(x, y);
    if (!el) return null;
    var card = el.closest('product-card');
    if (!card || !card.querySelector('.media--second')) return null;
    return card;
  }

  function activate(card) {
    if (releaseTimer) {
      clearTimeout(releaseTimer);
      releaseTimer = null;
    }
    if (card === activeCard) return;
    if (activeCard) activeCard.classList.remove(ACTIVE_CLASS);
    activeCard = card;
    if (activeCard) activeCard.classList.add(ACTIVE_CLASS);
  }

  function update() {
    rafPending = false;
    activate(cardAt(lastX, lastY));
  }

  function onTouch(event) {
    var t = event.touches && event.touches[0];
    if (!t) return;
    lastX = t.clientX;
    lastY = t.clientY;
    if (!rafPending) {
      rafPending = true;
      requestAnimationFrame(update);
    }
  }

  function onRelease() {
    if (!activeCard) return;
    if (releaseTimer) clearTimeout(releaseTimer);
    var card = activeCard;
    releaseTimer = setTimeout(function () {
      card.classList.remove(ACTIVE_CLASS);
      if (activeCard === card) activeCard = null;
      releaseTimer = null;
    }, RELEASE_DELAY);
  }

  var opts = { passive: true };
  document.addEventListener('touchstart', onTouch, opts);
  document.addEventListener('touchmove', onTouch, opts);
  document.addEventListener('touchend', onRelease, opts);
  document.addEventListener('touchcancel', onRelease, opts);
})();
